import { useState, useEffect } from 'react';
import { Box, Fade, useMediaQuery, useTheme } from '@mui/material';

import Content from './content';
import SideBar from './sidebar';

const styles = {
  container: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    height: 'auto',
  },
};

const DashboardLayout = ({ children }: { children: JSX.Element }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [isSideNavOpen, setIsSideNavOpen] = useState<boolean>(true);

  useEffect(() => {
    isMobile && setIsSideNavOpen(!isMobile);
  }, []);

  const toggleSideNav = () => {
    setIsSideNavOpen(!isSideNavOpen);
  };

  return (
    <>
      <Box sx={styles.container}>
        <SideBar isSideNavOpen={isSideNavOpen} />

        <Content content={children} isSideNavOpen={isSideNavOpen} toggleSideNav={toggleSideNav} />
      </Box>

      {isMobile && (
        <Fade in={isSideNavOpen} timeout={700}>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              width: '100vw',
              minHeight: '100vh',
              height: 'auto',
              backgroundColor: '#00000099',
            }}
            onClick={toggleSideNav}
          />
        </Fade>
      )}
    </>
  );
};

export default DashboardLayout;
